// Regex for Formatting U.S. Phone Number
// Ref to: https://stackoverflow.com/questions/8358084/regular-expression-to-reformat-a-us-phone-number-in-javascript#:~:text=Here%27s%20a%20version%20that%20allows%20the%20optional%20%2B1%20international%20code%3A

export function resolvePhoneNumberFormat(phoneNumberString: string) {
	const cleaned = ('' + phoneNumberString).replaceAll(/\D/g, '');
	const match = /^(?:1)?(\d{3})(\d{3})(\d{4})$/.exec(cleaned);
	if (match) {
		return ['(', match[1], ') ', match[2], '-', match[3]].join('');
	}
	return null;
}
